/* Spanish catalog mirroring locale-bank-archive-filter-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'bank.archive.filter.postingType': 'Tipo de asiento',
  'bank.archive.filter.purchase': 'Compra',
  'bank.archive.filter.otherSale': 'Otra venta',
  'bank.archive.filter.payment': 'Pago',
  'bank.archive.filter.manualPosting': 'Asiento manual',
  'bank.archive.filter.bankPosting': 'Asiento bancario',
  'bank.archive.filter.publicPayment': 'Nóminas e impuestos',
  'bank.archive.filter.ignored': 'Línea bancaria ignorada',
  'bank.archive.filter.documentation': 'Documentación',
  'bank.archive.filter.missingAttachment': 'Falta el justificante',
  'bank.archive.filter.hasAttachment': 'Con justificante',
  'bank.archive.sort.label': 'Ordenar asientos',
  'bank.archive.sort.statementOrder': 'Orden del extracto bancario',
  'bank.archive.sort.dateDesc': 'Fecha: más recientes primero',
  'bank.archive.sort.dateAsc': 'Fecha: más antiguos primero',
  'bank.archive.sort.amountDesc': 'Importe: mayor primero',
  'bank.archive.sort.amountAsc': 'Importe: menor primero'
});
